document.addEventListener(
  "DOMContentLoaded",
  function () {
    // Polyfill-ing, so we can use object-fit in IE.
    // eslint-disable-next-line no-unused-vars, no-undef
    objectFitImages(".js-polyfill-object-fit img");

    // Add smooth-scroll animation on all anchor # links.
    // eslint-disable-next-line no-unused-vars, no-undef
    const scroll = new SmoothScroll('a[href*="#"]');

    // Add a polyfill for working around problem in Instagram
    // webview. Fixes BUPL-AP in Sentry. See
    // https://developers.facebook.com/community/threads/320013549791141/.
    window._AutofillCallbackHandler =
      window._AutofillCallbackHandler || function () {};
  },
  { once: true },
);

// Add a forEach method to the Array object.
if (typeof window !== "undefined" && window.Array && !Array.prototype.forEach) {
  Array.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

// Add a forEach method to the NodeList object.
if (
  typeof window !== "undefined" &&
  window.NodeList &&
  !NodeList.prototype.forEach
) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
